import { IMaintenanceReview } from 'app/shared/model/maintenance-review.model';
import { ITruckImplement } from 'app/shared/model/truck-implement.model';
import { ICompany } from 'app/shared/model/company.model';

export interface IMaintenanceControl {
  id?: number;
  maintenance?: boolean | null;
  maintenanceReview?: IMaintenanceReview | null;
  truckImplement?: ITruckImplement | null;
  company?: ICompany | null;
}

export const defaultValue: Readonly<IMaintenanceControl> = {
  maintenance: false,
};
